<template>
  <div class="main">
    <div class="content">
      <!-- <el-date-picker
        v-model="time"
        @change='changeTime'
        :value-format='format'
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker> -->
      <el-table
        :data="tableData"
        class="tableContent"
        style="width: 100%">
        <el-table-column
          prop="name"
          label="公司名称">
        </el-table-column>
        <el-table-column
          prop="uname"
          label="联系人姓名">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="联系人手机号">
        </el-table-column>
        <el-table-column
          prop="ctime"
          label="申请时间">
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        layout="prev, pager, next"
        :current-page.sync='currentPage'
        :page-size='10'
        @current-change="handleCurrentChange"
        :total=total>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { listEdu } from "@/services/api";

export default {
  name: 'UserLayout',
  data() {
    return {
      tableData: [],
      currentPage: 1,
      total: 0,
      format: 'yyyy-MM-dd HH:mm:ss',
      time: '',
      startDate: undefined,
      endDate: undefined,
      activeName: 'first'
    }
  },
  mounted () { 
    this.getData()
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    getData() {
      let data = {
        page: this.currentPage,
        page_size: 10,
        status: 0,
        start_date: this.startDate,
        end_date: this.endDate
      }
      listEdu(data).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
        this.pageTotal = Math.ceil(this.total / 10)
      })
    },
    changeTime(data) {
      if (this.time.length === 2) {
        this.startDate = this.time[0]
        this.endDate = this.time[1]
      } else {
        this.startDate = undefined
        this.endDate = undefined
      }
      this.currentPage = 1
      this.getData()
    }
  },
  beforeDestroy () { }
}
</script>

<style lang="less" scoped>
.main{
  width: 100%;
  height: 100vh;
  background: #F7F7F7;
  .header{
    width: 100%;
    height: 111px;
    background: #FFFFFF;
    box-shadow: 0px 1px 11px 0px rgba(0, 0, 0, 0.05);
    display: flex;
    padding-left: 20px;
    box-sizing: border-box;
    align-items: center;
    img{
      height: 50px;
      margin-right: 10px;
    }
    span{
      font-size: 29px;
      font-weight: normal;
      color: #000000;
    }
  }
  .content{
    height: auto;
    padding: 20px;
    margin-top: -20px;
    background: #fff;
  }
}
.pagination{
  margin-top: 10px;
}
/deep/ .el-table .cell{
  line-height: normal;
  font-size: 20px;
}
.tableContent{
  margin-top: 20px;
}
</style>
<style>
  .el-date-table td span{
    font-size: 12px;
  }
  .el-picker-panel span{
    font-size: 12px;
  }
</style>
